<template>
    <div id="wrapper">
        <div class="dis-table">
            <div class="table-cell">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-sm-8">
                            <div class="page-title mb-4 text-dark">{{i18n('Tickets')}}</div>
                            <div id="carouselCheck" class="carousel slide" data-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item" v-for="(ticket, k) in tickets" :class="{'active': k === 0}">
                                        <img :src="ticket.image" alt=""/>
                                    </div>
                                </div>
                                <a class="carousel-control-prev control-item" href="#carouselCheck" role="button" data-slide="prev">
                                </a>
                                <a class="carousel-control-next control-item" href="#carouselCheck" role="button" data-slide="next"></a>
                            </div>
                            <p class="txt">{{i18n('Take a picture or')}}</p>
                            <div class="row justify-content-center">
                                <div class="col-6">
                                    <button type="button" class="btn btn-primary btn-next" @click="printImage">{{i18n('Print out')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div><!--/wrapper-->
</template>

<script>
    export default {
        data() {
            return {
                tickets: []
            }
        },
        created() {
            if (!this.$store.state.order.id) {
                this.$router.push({name: 'web'});
            }
            axios.get('/api/qr/images', {params: {order_id: this.$store.state.order.id}})
                .then(res => {
                    this.tickets = res.data.data.tickets;
                    this.$store.state.selectedSeats = [];
                })
        },
        methods: {
            printImage() {
                window.print();
            }
        }
    }
</script>
<style scoped>
    #wrapper {
        background-color: #fff;
    }
</style>
